module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/rotate_hover_CM.6805646c.svg";